import Dialog from './Dialog.js';

class ActivationSuccessDialog extends Dialog {
    static create(params) {
        return new ActivationSuccessDialog(params);
    }

    setInstitutionName(institutionName) {
        this.find('.institution-name').text(institutionName);
        return this;
    }
}

export default ActivationSuccessDialog;